<template>
  <div id='box'>
    <div id='calendar'>
      <div class='month'>
        <ul>
          <li class='arrow' @click='_pickPre(currentYear, currentMonth)'>
            <img src='../../assets/live/calendar_left_btn.png'/>
          </li>
          <li class='year-month'>
            <span>{{currentYear}} {{strUtils(currentMonth)}}</span>
          </li>
          <li class='arrow' @click='_pickNext(currentYear, currentMonth)'>
            <img src='../../assets/live/calendar_right_btn.png'/>
          </li>
        </ul>

        <li class='date-week'>
          <span class='this-date'>{{getCurDate}}</span>
          <span class='this-weekday'>{{getCurWeek}}</span>
        </li>
      </div>
      <ul class='weekdays'>
        <li>一</li>
        <li>二</li>
        <li>三</li>
        <li>四</li>
        <li>五</li>
        <li>六</li>
        <li>日</li>
      </ul>
      <ul class='days'>
        <li v-for='dayObj in days' :key='dayObj.day.index' @click='_selectDateLives(dayObj)'>
          <div :class="{'other-month': dayObj.isOtherMonth, 'active': dayObj.isActive, 'today': dayObj.isToday, 'date-size': true}">
              <span>{{ dayObj.day.getDate() }}</span>
             <img class="dot-class" v-if='dayObj.isHaveRooms && !dayObj.isActive' src='../../assets/live/calendar_tip_dot.png'>
             <img class="dot-class" v-else-if='dayObj.isHaveRooms && dayObj.isActive' src='../../assets/live/calendar_tip_dot_white.png'>
             <div class="dot-class" v-else></div>
          </div>

        </li>
      </ul>
      <back-today-btn class='back-today' @click='_backToday'></back-today-btn>
    </div>

  </div>
</template>

<script>
import dateUtils from '@/common/dateUtils.js'
import strUtils from '@/common/strUtils.js'
import backTodayBtn from './button/backtoday_btn.vue'
export default {
  name: 'Calendar',
  components: {
    backTodayBtn
  },
  data () {
    return {
      preSelectedDay: null,
      currentDay: null,
      currentMonth: 1,
      currentYear: 1970,
      currentWeek: null,
      days: []
    }
  },
  created () {
    this._initData(null)
  },
  methods: {
    strUtils (val) {
      return strUtils.intTo2Str(val)
    },
    // _ 开头标识私有方法，不建议调用
    _backToday () {
      this._initData(null)
    },
    _selectDateLives (dayObj) {
      this._thisDateTime(dayObj.day)
      this.preSelectedDay.isActive = false
      dayObj.isActive = true
      this.preSelectedDay = dayObj
    },
    _thisDateTime (date) {
      this.currentDay = date.getDate()
      this.currentWeek = date.getDay()
      this.currentMonth = date.getMonth() + 1
      this.currentYear = date.getFullYear()
      this.$emit('selectDateClick', dateUtils.dateFormat('YYYY-mm-dd', date))
    },
    _initData (cur) {
      let date, d, i, dayObj

      if (cur) {
        date = new Date(cur)
        this._thisDateTime(date)
      } else {
        let curDate = new Date()
        this._thisDateTime(curDate)
        date = new Date(dateUtils.formatDate(curDate.getFullYear(), curDate.getMonth() + 1, 1))
      }
      let day = date.getDate()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let week = date.getDay()

      if (this.week === 0) {
        this.week = 7
      }

      let str = dateUtils.formatDate(year, month, day)

      this.days.length = 0
      // 当前月第一周1号之前的日期
      for (i = week - 1; i >= 0; i--) {
        d = new Date(str)
        d.setDate(d.getDate() - i)

        dayObj = {day: d, isOtherMonth: false, isHaveRooms: false, isActive: false, index: dateUtils.formatDate(d.getFullYear(), d.getMonth() + 1, d.getDate()), isToday: false}

        if (d.getMonth() + 1 !== month) {
          dayObj.isOtherMonth = true
        }

        let curDate = new Date()
        if (!cur && d.getFullYear() === curDate.getFullYear() && d.getMonth() === curDate.getMonth() && d.getDate() === curDate.getDate()) {
          dayObj.isActive = true
          dayObj.isToday = true
          this.preSelectedDay = dayObj
        }

        if (cur && d.getFullYear() === year && d.getMonth() + 1 === month && d.getDate() === 1) {
          dayObj.isActive = true
          dayObj.isToday = true
          this.preSelectedDay = dayObj
        }

        this.days.push(dayObj)
      }

      // 其他周
      for (i = 1; i <= 35 - week; i++) {
        d = new Date(str)
        d.setDate(d.getDate() + i)
        dayObj = {day: d, isOtherMonth: false, isHaveRooms: false, isActive: false, index: dateUtils.formatDate(d.getFullYear(), d.getMonth() + 1, d.getDate())}

        if (d.getMonth() + 1 !== month) {
          dayObj.isOtherMonth = true
        }

        let curDate = new Date()
        if (!cur && d.getFullYear() === curDate.getFullYear() && d.getMonth() === curDate.getMonth() && d.getDate() === curDate.getDate()) {
          dayObj.isActive = true
          dayObj.isToday = true
          this.preSelectedDay = dayObj
        }

        this.days.push(dayObj)
      }

      this.$emit('selectMonth', this.currentYear, this.currentMonth)
    },
    _pickPre (year, month) {
      let d = new Date(dateUtils.formatDate(year, month, 1))
      d.setDate(0)
      this._selectMonth(d)
    },
    _pickNext (year, month) {
      var d = new Date(dateUtils.formatDate(year, month, 1))
      d.setDate(35)
      this._selectMonth(d)
    },

    _selectMonth (d) {
      let day = dateUtils.formatDate(d.getFullYear(), d.getMonth() + 1, 1)
      this._initData(day)
    },

    // 对外提供的方法
    // 更新当前打点数据
    updatePointData (array) {
      this.days.forEach(vDay => {
        var _day = dateUtils.formatDate1(vDay.day.getFullYear(), vDay.day.getMonth() + 1, vDay.day.getDate())
        if (array.indexOf(_day) !== -1) {
          vDay.isHaveRooms = true
        }
      })
    }
  },
  computed: {
    getCurDate: function () {
      return strUtils.intTo2Str(this.currentDay)
    },
    getCurWeek: function () {
      return dateUtils.formatWeek(this.currentWeek)
    }
  }
}
</script>

<style scoped>
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  ul {
    list-style-type: none;
  }
  #box {
  }
  #calendar{
    width: 266px;
    margin: 0 auto;
    margin: 18px;
    /* box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.1), 0 1px 5px 0 rgba(0,0,0,0.12); */
  }
  .month {
    width: 100%;
  }
  .month ul {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
  }
  .year-month {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    font-size: 15px;
    color: #52626D;
  }
  .date-week {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
  }
  .this-date {
    font-family: 'PingFangSC-Medium';
    font-size: 36px;
    color: #54636E;
    letter-spacing: 0;
    text-align: center;
  }
  .this-weekday {
    font-family: 'PingFangSC-Regular';
    font-size: 14px;
    color: #54636E;
    letter-spacing: 0;
    text-align: center;
  }
  .choose-year {
    padding-left: 20px;
    padding-right: 20px;
  }
  .choose-month {
    text-align: center;
    font-size: 1.5rem;
  }
  .arrow {
    cursor: pointer;
  }
  .month ul li {
    font-family: 'PingFangSC-Regular';
    font-size: 15px;
    color: #52626D;
    letter-spacing: 0;
    text-align: center;
    line-height: 15px;
  }
  .weekdays {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    color: #FFFFFF;
    justify-content: space-around;
  }
  .weekdays li {
    display: inline-block;
    width: 38px;
    height: 38px;
    text-align: center;

    font-family: 'PingFangSC-Regular';
    font-size: 13px;
    line-height: 38px;
    color: #919EAB;
    letter-spacing: 0;
    text-align: center;
  }
  .days {
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .other-month {
    color: #C4CDD5 ;
  }
  .days li {
    font-family: 'PingFangSC-Regular';
    font-size: 15px;
    color: #67757E;
    letter-spacing: 0;
    text-align: center;
    line-height: 14.96px;

    list-style-type: none;
    display: inline-block;
    width: 38px;
    height: 38px;
    cursor: pointer;
  }
  .date-size {
    margin: 0 auto;
    width: 36px;
    height: 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
  }
  .checked {
    background: #919EAB;
    color: #fff;
  }
  .active {
    background: #5DC0BA;
    color: #fff;
    border-radius: 50% ;
  }

  .today{
    border: #5DC0BA solid 1px;
    border-radius: 50% ;
  }
  .days li:hover {
/*    background: #e1e1e1; */
  }

  .back-today {
    margin-left: 0px;
    margin-top: 19px;
  }
  .dot-class{
    width: 4px;
    height: 4px;
    margin-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/live/Calendar.vue